import { cartItem } from "../types/cart";

// get product discount price
export const getDiscountPrice = (price: number, discount: number): number => {
  return discount && discount > 0
    ? Number((price - price * (discount / 100)).toFixed(2))
    : price;
};

// get products
export const getProducts = (products: any[], limit: number, type?: string, category?: any) => {
  const finalProducts = category
    ? products.filter(
        product => product.category.filter((single: any) => single === category)[0]
      )
    : products;
  
  if(!finalProducts) return null;
  const prodArray = [...finalProducts]

  if (type && type === "bestSeller") {
    return prodArray.sort((a, b) => b.saleCount - a.saleCount).slice(0, limit ? limit : finalProducts.length)
  }
  return finalProducts.slice(0, limit ? limit : finalProducts.length);
};

// get product cart quantity
export const getProductCartQuantity = (cartItems: any[], product: any, color: string) => {
  let productInCart = cartItems.filter(
    single =>
      single.id === product.id &&
      (single.selectedProductColor
        ? single.selectedProductColor === color
        : true)
  )[0];
  if (cartItems.length >= 1 && productInCart) {
    if (product.variation) {
      return cartItems.filter(
        single =>
          single.id === product.id && single.selectedProductColor === color
      )[0].quantity;
    } else {
      return cartItems.filter(single => product.id === single.id)[0].quantity;
    }
  } else {
    return 0;
  }
};

// shop top filter toggle
export const toggleShopTopFilter = (e: any) => {
  const shopTopFilterWrapper: any = document.querySelector("#shop-filter-menu");
  if (!shopTopFilterWrapper) {
    return
  }
  shopTopFilterWrapper.classList.toggle("active");
  if (shopTopFilterWrapper.style.height) {
    shopTopFilterWrapper.style.height = null;
  } else {
    shopTopFilterWrapper.style.height =
      shopTopFilterWrapper.scrollHeight + "px";
  }
  e.currentTarget.classList.toggle("active");
};

// get individual element
const getIndividualItemArray = (array: any[]) => {
  let individualItemArray = array.filter(function(v, i, self) {
    return i === self.indexOf(v);
  });
  return individualItemArray;
};

// get individual categories
export const getIndividualCategories = (products: any[]) => {
  let productCategories: any[] = [];
  products &&
    products.map(product => {
      return (
        product.category &&
        product.category.map((single: any) => {
          return productCategories.push(single);
        })
      );
    });
  const individualProductCategories = getIndividualItemArray(productCategories);
  return individualProductCategories;
};

// get individual colors
export const getIndividualColors = (products: any[]) => {
  let productColors: any[] = [];
  products &&
    products.map(product => {
      return (
        product.variation &&
        product.variation.map((single: any) => {
          return productColors.push(single.color);
        })
      );
    });
  const individualProductColors = getIndividualItemArray(productColors);
  return individualProductColors;
};

//get products based on filter
export const getSortedProducts = (products: any[], sortType: string, sortValue: string) => {
  if (products && sortType && sortValue) {
    if (sortType === "category") {
      return products.filter(
        product => product.category.filter((single: any) => single === sortValue)[0]
      );
    }

    if (sortType === "color") {
      return products.filter(
        product =>
          product.variation &&
          product.variation.filter((single: any) => single.color === sortValue)[0]
      );
    }
  }
  return products;
};

export const setActiveSort = (e: any) => {
  const filterButtons = document.querySelectorAll(
    ".shop-filter-block__color li button, .shop-filter-block__category li button"
  );
  filterButtons.forEach(item => {
    item.classList.remove("active");
  });
  e.currentTarget.classList.add("active");
};

// get stock of cart item
export const cartItemStock = (item: cartItem, color: string) => {
  if (item.stock) {
    return item.stock;
  } else {
    return item.variation.filter((single: any) => single.color === color)[0].stock;
  }
};
